import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=5f782640&scoped=true&"
import script from "./GeneralSettings.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&id=5f782640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f782640",
  null
  
)

export default component.exports